import { Link } from 'react-router-dom';
import { useLiveStats } from '../hooks/useApi';

export default function IngestProgressBanner() {
  const { data: live } = useLiveStats();
  const status = live?.ingestStatus;

  if (!status || status.status === 'idle' || status.status === 'completed' || status.status === 'error') {
    return null;
  }

  const active = status.status === 'pending' || status.status === 'running';
  const percent = status.percentComplete ?? 0;

  return (
    <div className="bg-[var(--card)]/80 px-4 py-2 text-xs backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
        <div className="flex items-center gap-3 overflow-hidden">
          <span
            className={`h-2 w-2 shrink-0 rounded-full ${
              active ? 'animate-pulse bg-[var(--success)]' : 'bg-[var(--warning)]'
            }`}
          />
          <span className="truncate text-[var(--fg)]">
            Ingestion <span className="font-medium">{status.status}</span>
            {status.fetchedRecords !== undefined && (
              <>
                {' '}
                — {(status.fetchedRecords).toLocaleString()} /{' '}
                {(status.totalRecords ?? 0).toLocaleString()} records ({percent}%)
              </>
            )}
          </span>
        </div>
        <Link
          to="/ingest"
          className="shrink-0 rounded border border-[var(--border)] bg-[var(--bg)] px-2 py-1 font-medium text-[var(--fg)] hover:border-[var(--primary)]/40"
        >
          View
        </Link>
      </div>
      {active && percent < 100 && (
        <div className="mx-auto mt-1.5 h-1 max-w-7xl overflow-hidden rounded-full bg-[var(--border)]">
          <div
            className="h-full bg-[var(--success)] transition-all duration-500"
            style={{ width: `${percent}%` }}
          />
        </div>
      )}
    </div>
  );
}
